import { TmsRouteType } from 'app/constants/tmsRouteType'

export const getTmsRouteType = (type) => {
  let tmsRouteType = TmsRouteType.Undefined

  switch (type) {
    case 1:
      tmsRouteType = TmsRouteType.Bilateral
      break
    case 2:
      tmsRouteType = TmsRouteType.Cabotage
      break
    case 3:
      tmsRouteType = TmsRouteType.CrossTrade
      break
    case 4:
      tmsRouteType = TmsRouteType.Transit
      break
    case 5:
      tmsRouteType = TmsRouteType.PolishTransit
      break
    case 6:
      tmsRouteType = TmsRouteType.Import
      break
    case 7:
      tmsRouteType = TmsRouteType.Export
      break
    case 8:
      tmsRouteType = TmsRouteType.CrossTradeBilateral
      break
    case 9:
      tmsRouteType = TmsRouteType.CrossTradeWrong
      break
    case 10:
      tmsRouteType = TmsRouteType.CabotageEmpty
      break
    case 11:
      tmsRouteType = TmsRouteType.CrossTradeBilateralEmpty
      break
    case 12:
      tmsRouteType = TmsRouteType.CrossTradeWrongEmpty
      break
    case 13:
      tmsRouteType = TmsRouteType.Empty
      break
    case 14:
      tmsRouteType = TmsRouteType.Domestic
      break
  }

  return tmsRouteType
}
